import {useStyles} from './QueryControl.styles';
import TimeControl, {TimeValue} from "../TimeControl/TimeControl";
import AggregationControl from "../AggregationControl/AggregationControl";
import {Aggregation, Conditions} from "../../@types/Query";
import ConditionsControl, {defaultValue as defaultConditions} from "../ConditionsControl/ConditionsControl";
import Button from "../Button/Button";

export type QueryState = {
    time: TimeValue
    aggregation: Aggregation
    conditions?: Conditions
}

type Props = {
    value: QueryState,
    onChange: (value: QueryState) => void
    className?: string
}

const QueryControl = (
    {
        value,
        onChange,
        className
    }: Props
) => {
    const styles = useStyles();

    const handleTimeChange = (time: TimeValue) => {
        onChange({
            ...value,
            time,
        });
    }
    const handleAggregationChange = (aggregation: Aggregation) => {
        onChange({
            ...value,
            aggregation,
        })
    }
    const handleWhereChange = (conditions: Conditions|undefined) => {
        onChange({
            ...value,
            conditions: conditions,
        })
    }

    return (
        <div className={`${styles.component} ${className}`}>
            <div className={styles.time}>
                <AggregationControl
                    value={value.aggregation}
                    onChange={handleAggregationChange}
                />
                <TimeControl
                    value={value.time}
                    aggregation={value.aggregation}
                    onChange={handleTimeChange}
                />
            </div>

            {value.conditions ?
                <div>
                    <ConditionsControl
                        conditions={value.conditions}
                        onChange={handleWhereChange}
                    />
                    <Button
                        className={styles.deleteFilter}
                        variant="text"
                        onClick={()=>{
                            if(window.confirm("Filter wirklich löschen?")){
                                handleWhereChange(undefined)
                            }
                        }}
                    >
                        Filter löschen
                    </Button>
                </div>
                : null
            }

            {!value.conditions ?
                <Button
                    variant="outline"
                    onClick={() => {
                        handleWhereChange(defaultConditions);
                    }}
                >Filter</Button>
                : null
            }
        </div>
    )
}

export default QueryControl